import helper from '@utils/helper';
import { I18n } from '@utils/index';

import { openGiveUpSet } from '../GiveUpSet';
import { openSetPassword } from '../SetPassword';
import { IDataRef } from './type';

interface IParams {
  dataRef: IDataRef;
  cb: () => void;
  theme: Theme;
  firstModalTitle: string;
}

export const useSetPwd = (params: IParams) => {
  const { dataRef, theme, cb, firstModalTitle } = params;
  const setPwd = async () => {
    const pwdRes = await openSetPassword({
      title: firstModalTitle,
      theme,
      closeHook: () => openGiveUpSet({ theme }),
      onComplete: async () => {
        return {
          status: 'DONE'
        }
      }
    })
    if (pwdRes === 'cancel') return;
    const res = await openSetPassword({
      title: I18n.t('pq7Lbk5q'),
      theme,
      closeHook: () => openGiveUpSet({ theme }),
      onForgetPwd: (close) => {
        close();
        setPwd();
      },
      onComplete: async (value) => {
        if (value === pwdRes) {
          return { status: 'DONE' }
        }
        return { errorText: I18n.t('forgetPass_step_three_password_error') };
      }
    })
    if (res === 'cancel') return;
    dataRef.current.assetPwd = helper.md5(pwdRes);
    dataRef.current.reAssetPwd = helper.md5(res);
    cb()
  }
  return {
    setPwd
  }
}
